var _rect, _rect2, _rect3, _path, _rect4, _rect5, _path2, _rect6, _rect7, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVizIcon = function SvgVizIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 80,
    viewBox: "0 0 160 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 80,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 24.5,
    width: 41,
    height: 41,
    rx: 8.5,
    fill: "#EDEDED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 24.5,
    width: 41,
    height: 41,
    rx: 8.5,
    stroke: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 33C16 31.8937 15.1063 31 14 31C12.8937 31 12 31.8937 12 33V54C12 56.7625 14.2375 59 17 59H42C43.1063 59 44 58.1063 44 57C44 55.8937 43.1063 55 42 55H17C16.45 55 16 54.55 16 54V33ZM41.4125 38.4125C42.1938 37.6313 42.1938 36.3625 41.4125 35.5813C40.6313 34.8 39.3625 34.8 38.5812 35.5813L32 42.1687L28.4125 38.5813C27.6313 37.8 26.3625 37.8 25.5813 38.5813L18.5813 45.5812C17.8 46.3625 17.8 47.6313 18.5813 48.4125C19.3625 49.1938 20.6313 49.1938 21.4125 48.4125L27 42.8313L30.5875 46.4188C31.3687 47.2 32.6375 47.2 33.4188 46.4188L41.4188 38.4187L41.4125 38.4125Z",
    fill: "#6F6F6F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 14.5,
    width: 41,
    height: 41,
    rx: 8.5,
    fill: "#EDEDED"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 14.5,
    width: 41,
    height: 41,
    rx: 8.5,
    stroke: "#EDEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81 34V20.0375C81 19.475 81.4375 19 82 19C89.7313 19 96 25.2688 96 33C96 33.5625 95.525 34 94.9625 34H81ZM64 36C64 28.4187 69.6312 22.1437 76.9375 21.1437C77.5125 21.0625 78 21.525 78 22.1063V37L87.7812 46.7812C88.2 47.2 88.1688 47.8875 87.6875 48.225C85.2375 49.975 82.2375 51 79 51C70.7188 51 64 44.2875 64 36ZM96.9 37C97.4813 37 97.9375 37.4875 97.8625 38.0625C97.3812 41.5562 95.7 44.6625 93.2437 46.9562C92.8687 47.3062 92.2812 47.2812 91.9188 46.9125L82 37H96.9Z",
    fill: "#6F6F6F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 24.5,
    width: 41,
    height: 41,
    rx: 8.5,
    fill: "#EDEDED"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 24.5,
    width: 41,
    height: 41,
    rx: 8.5,
    stroke: "#EDEDED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144 31.001C146.206 31.001 148 32.7916 148 35.001V55.001C148 57.2072 146.206 59.001 144 59.001H120C117.791 59.001 116 57.2072 116 55.001V35.001C116 32.7916 117.791 31.001 120 31.001H144ZM130.5 45.501V39.001H119V45.501H130.5ZM119 48.501V55.001C119 55.551 119.447 56.001 120 56.001H130.5V48.501H119ZM133.5 56.001H144C144.55 56.001 145 55.551 145 55.001V48.501H133.5V56.001ZM145 45.501V39.001H133.5V45.501H145Z",
    fill: "#6F6F6F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVizIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/viz-icon.774e291bfb8f0171e9b5327887c1fbb2.svg";